var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardQuickMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5880_8695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6576 17.8348V20.1783C37.6576 29.8219 29.8348 37.6616 20.1744 37.6616H17.8309C8.18731 37.6616 0.347656 29.8388 0.347656 20.1783V1.09338C0.347656 0.688751 0.684843 0.351562 1.08947 0.351562H20.1744C29.818 0.351562 37.6576 8.17436 37.6576 17.8348Z",
    stroke: "#c1f700",
    strokeWidth: 0.58104,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1387 7.72363C18.4048 7.09807 19.2993 7.09501 19.583 7.72461C20.7813 10.56 21.9772 12.574 23.584 14.1787C25.1909 15.7835 27.205 16.9754 30.0322 18.1738C30.6581 18.4399 30.6613 19.3346 30.0312 19.6182C27.1962 20.8164 25.1827 22.0126 23.5781 23.6191C21.9734 25.226 20.7814 27.2402 19.583 30.0674C19.3171 30.693 18.4227 30.6965 18.1387 30.0674C16.9402 27.2317 15.7436 25.218 14.1367 23.6133C12.5298 22.0085 10.5159 20.8166 7.68848 19.6182C7.06324 19.3523 7.05927 18.4573 7.6875 18.1729L7.68848 18.1738C10.5244 16.9754 12.5387 15.7788 14.1436 14.1719C15.7483 12.565 16.9403 10.5509 18.1387 7.72363Z",
    fill: "#c1f700",
    stroke: "#c1f700",
    strokeWidth: 0.116208
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8148 0.351562H1.17377C0.717521 0.351562 0.347656 0.721426 0.347656 1.17767V36.8187C0.347656 37.2749 0.717521 37.6447 1.17377 37.6447H36.8148C37.271 37.6447 37.6408 37.2749 37.6408 36.8187V1.17767C37.6408 0.721426 37.271 0.351562 36.8148 0.351562Z",
    stroke: "#c1f700",
    strokeWidth: 0.58104,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5880_8695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardQuickMenuIcon);
export default __webpack_public_path__ + "static/media/dashboard-quick-menu-icon.b2e3bc9225402fd814808519c5d01951.svg";
export { ForwardRef as ReactComponent };